import React from "react";
import ModalBox from "../../components/modal/ModalBox";
import {
  catchMessage,
  elseMessage,
  successMessage,
} from "../../comman/Message";
import { changeMeetupsStatusApi } from "../../services/meetups";
const ChangeMeetupsStatus = ({ show, close, status, id, listing, name }) => {
  //--------------change-status-meetups-------------------------
  const changeStatus = async () => {
    try {
      let data = { status: !status, id: id };
      const res = await changeMeetupsStatusApi(data);
      if (res.data.status === 200) {
        close();
        listing();
        successMessage(res);
      } else {
        elseMessage(res);
      }
    } catch (e) {
      catchMessage(e);
    }
  };

  return (
    <ModalBox
      status={show}
      onClose={close}
      title={`${status ? "Block" : "Unblock"} Meetups`}
      description={
        <span>
          Do you want to {!status ? "Unblock" : "block"} <strong>{name}</strong>{" "}
          ?
        </span>
      }
      action={changeStatus}
    />
  );
};

export default ChangeMeetupsStatus;
